<template>
  <div>
    <VueSlider
      v-model="internalSelected"
      :adsorb="true"
      :data="speedData"
      :tooltip="'none'"
      :tooltip-placement="'bottom'"
      @change="selectAndEmit"
    />
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";

export default {
  name: "SpeedChooser",
  components: {
    VueSlider
  },
  props: {
    data: { type: Array, default: () => [] },
    index: { type: Number, default: 0 },
    selected: { type: Object, default: () => {} }
  },
  data() {
    return {
      internalSelected: "",
      speedData: []
    };
  },
  watch: {
    selected: {
      handler: function(newVal) {
        if (typeof newVal !== "undefined") {
          this.internalSelected = newVal.value_description;
        } else {
          this.internalSelected = "normal";
          this.selectAndEmit(this.internalSelected);
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.mapData();
  },
  methods: {
    mapData() {
      let dataArray = [];
      for (let i = 0; i < this.data.length; i++) {
        dataArray.push(this.data[i].value_description);
      }
      this.speedData = dataArray;
    },
    selectAndEmit(newVal) {
      this.$emit(
        "input",
        this.data.find(x => x.value_description === newVal),
        this.index
      );
    }
  }
};
</script>

<style scoped></style>
